/*
 * This enum is used in data contracts with clients - anything
 * added here needs to be communicated to all client teams so
 * that the corresponding event can be added to corresponding client
 * enum (ie: 'OutgoingBreakoutMessageFunction' for BreakoutRoom[Action])
 * and handled appropriately
*/

export enum EventTriggers {
    BreakoutRoomActiveUsersUpdated = 'breakout_room_active_users_updated',
    BreakoutRoomCreatorStateUpdated = 'breakout_room_creator_state_updated',
    BreakoutRoomStartedStatusUpdated = 'breakout_room_started_updated'
}
